// TODO изменить user_id => owner_id?
export default {
  // user
  user_id: undefined, // owner ID
  id: undefined, // user ID
  login: '',
  created_at: '',
  updated_at: '',
  primary_group: null,
  isOwner: false,
  setUserData (userData) {
    this.isOwner = userData.user_id === userData.id
    Object.keys(userData).forEach((prop) => {
      this[prop] = userData[prop]
    })
  },

  // profile
  profile_id: '',
  profile_user_id: '',
  email: '',
  phone: '',
  full_name: '',
  organization: '',
  timezone: 'MSK',
  setUserProfile (profileData) {
    if (!profileData) {
      console.warn('Set user profile: not profile data')
      return
    }

    Object.keys(profileData).forEach((prop) => {
      if (prop === 'user_id') {
        this.profile_user_id = profileData[prop]
        return
      } if (prop === 'id') {
        this.profile_id = profileData[prop]
        return
      }
      this[prop] = profileData[prop]
    })
  },

  // settings
  filespot: {
    home_dir: {}
  },
  autotranscoding: {
    enabled: false,
    presets: [], // presets_id[]
    del_original: false,
    sftp: true
  },
  private_files: {
    default: false
  },
  multifactor_enabled: false,

  setUserSettings (settingsData) {
    Object.keys(settingsData).forEach((prop) => {
      this[prop] = settingsData[prop]
    })
  },

  // available services
  services: [],
  administrator: false,
  read_only: false,
  setUserAccess (accessData) {
    Object.keys(accessData).forEach((prop) => {
      this[prop] = accessData[prop]
    })
  },

  get isUnixRoot () {
    return !!(this.primary_group === null || this.primary_group === '')
  }
}
